export default {
  app: {
    // Menu name translations (key = Chinese name from DB)
    menu: {
      '首页': 'Home',
      '仪表盘': 'Dashboard',
      '系统管理': 'System',
      '用户管理': 'Users',
      '角色管理': 'Roles',
      '菜单管理': 'Menus',
      '素材管理': 'Material',
      '素材库': 'Library',
      '素材采集': 'Scraper',
      '下载任务': 'Downloads',
      'FB采集': 'FB Scraper',
      '报表中心': 'Reports',
      '消耗明细': 'Insights',
      '书籍汇总': 'Book Summary',
      '有素材明细的书籍': 'Books with Material Details',
      '素材消耗': 'Consumption',
      'Facebook 账户绑定': 'FB Binding',
      '标签管理': 'Tags',
      '数据面板': 'Dashboard',
      '广告管理': 'Ads',
      '广告模板': 'Templates',
      '批量创建': 'Batch Create',
      '批量创建(测试)': 'Batch Create (Test)',
      '开发工具': 'Dev Tools',
      '定时任务': 'Jobs',
      '定时任务日志': 'Job Logs',
      '系统配置': 'Configs',
      '部门管理': 'Departments',
      'FB调试工具': 'FB Debug'
    },
    // Header
    home: 'Home',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
    unknownPage: 'Unknown',
    user: 'User',
    // Tab context menu
    tabCloseCurrent: 'Close Current',
    tabCloseLeft: 'Close Left',
    tabCloseRight: 'Close Right',
    tabCloseOthers: 'Close Others',
    tabCloseAll: 'Close All'
  },
  common: {
    search: 'Search',
    reset: 'Reset',
    close: 'Close',
    confirm: 'OK',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    export: 'Export',
    operation: 'Action',
    status: 'Status',
    createTime: 'Created At',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    detail: 'Detail',
    image: 'Image',
    video: 'Video',
    exportLargeTitle: 'Large export',
    exportLargeMessage: 'About {count} rows will be exported (over 10,000). Continue?',
    exportCountFail: 'Failed to get export row count. Please try again.',
    /** Shared book column label & search placeholder (matches backend fuzzy book name filter) */
    bookName: 'Book Name',
    bookNameSearchPlaceholder: 'Fuzzy search by book name',
    consumptionDate: 'Date Range',
    dateRangeSep: 'to',
    dateStart: 'Start Date',
    dateEnd: 'End Date',
    min: 'Min',
    max: 'Max',
    sortDesc: 'Descending',
    sortAsc: 'Ascending'
  },
  facebook: {
    title: 'Facebook Account Binding',
    // Status alerts
    authExpired: 'Authorization Expired',
    authExpiredDesc: 'The bound Facebook authorization token has expired or been revoked. Please re-authorize.',
    reAuth: 'Re-authorize',
    notBound: 'Not Bound',
    notBoundDesc: 'Please authorize and bind first',
    authSuccess: 'Authorized',
    tokenActive: 'Token is active',
    // Buttons
    bindFacebook: 'Bind Facebook Account',
    unbind: 'Unbind',
    refreshBm: 'Refresh BM/Accounts',
    addOAuth: 'Add OAuth',
    addToken: 'Add Token Binding',
    // Table
    accountCount: 'Bound Facebook Accounts ({count})',
    accountName: 'Account Name',
    bindType: 'Bind Type',
    primaryAccount: 'Primary',
    bindTime: 'Bound At',
    editName: 'Edit Name',
    saveName: 'Save',
    setPrimary: 'Set Primary',
    // Token bind dialog
    tokenDialogTitle: 'Bind Facebook Account via Token',
    tokenType: 'Token Type',
    tokenTypeBm: 'BM Token',
    tokenTypeAccount: 'Account Token',
    accessToken: 'Access Token',
    accessTokenPlaceholder: 'Enter Facebook Access Token',
    adAccountId: 'Ad Account ID',
    adAccountIdPlaceholder: 'e.g. act_123456',
    tokenName: 'Token Name (optional)',
    tokenNamePlaceholder: 'Give this token a name',
    confirmBind: 'Confirm Bind',
    // Validation
    tokenRequired: 'Please enter an Access Token',
    adAccountRequired: 'Ad Account ID is required for Account Tokens',
    // Bind type text
    bindTypeOAuth: 'OAuth',
    bindTypeToken: 'Token',
    // Status text
    statusActive: 'Active',
    statusInactive: 'Expired',
    // Messages
    unbindConfirm: 'Are you sure to unbind? You will need to re-authorize.',
    unbindSuccess: 'Unbound successfully',
    bindSuccess: 'Bound successfully',
    deleteConfirm: 'Are you sure to delete this account?',
    deleteSuccess: 'Deleted successfully',
    setPrimarySuccess: 'Set as primary account',
    nameUpdateSuccess: 'Name updated',
    refreshSuccess: 'BM/Accounts refreshed'
  },
  consumption: {
    // Search form
    materialName: 'Material Name',
    materialNamePlaceholder: 'Fuzzy search',
    numericId: 'Material ID',
    numericIdPlaceholder: 'Enter to add, paste multiple',
    materialId: 'FB Material ID',
    materialIdPlaceholder: 'Exact external ID match',
    materialType: 'Material Type',
    fileType: 'File Type',
    fileTypePlaceholder: 'e.g. image/jpeg',
    adAccountId: 'Ad Account ID',
    adAccountIdPlaceholder: 'Ad Account ID',
    adId: 'Ad ID',
    adIdPlaceholder: 'Facebook Ad ID',
    tag: 'Tags',
    tagPlaceholder: 'All tags',
    uploader: 'Uploader',
    uploaderPlaceholder: 'All uploaders',
    namingStrategy: 'Naming strategy',
    namingStrategyPlaceholder: 'All strategies',
    metricFilter: 'Metric filters',
    hideMetricFilter: 'Collapse',
    adCountMin: 'Ad Count Min',
    adCountMinPlaceholder: 'Min ad count',
    adCountMax: 'Ad Count Max',
    adCountMaxPlaceholder: 'Max ad count',
    spendMin: 'Spend Min',
    spendMinPlaceholder: 'Min spend',
    spendMax: 'Spend Max',
    spendMaxPlaceholder: 'Max spend',
    ctrMin: 'CTR Min',
    ctrMax: 'CTR Max',
    purchasesMin: 'Purchases Min',
    purchasesMinPlaceholder: 'Min purchases',
    purchasesMax: 'Purchases Max',
    purchasesMaxPlaceholder: 'Max purchases',
    roiMin: 'ROI Min',
    roiMinPlaceholder: 'Min ROI',
    roiMax: 'ROI Max',
    roiMaxPlaceholder: 'Max ROI',
    costPerPurchaseMin: 'Cost/Purchase Min',
    costPerPurchaseMinPlaceholder: 'Min cost per purchase',
    costPerPurchaseMax: 'Cost/Purchase Max',
    costPerPurchaseMaxPlaceholder: 'Max cost per purchase',
    onlyWithSpend: 'Spend Only',
    queryEngine: 'Query Engine',
    exportExcel: 'Export Excel',
    // Date shortcuts
    last7days: 'Last 7 days',
    last30days: 'Last 30 days',
    last90days: 'Last 90 days',
    // Empty data
    noDataTitle: 'No consumption data in the selected date range',
    noDataDesc: 'Try adjusting the date range or turn off the "Spend Only" filter to see all materials.',
    // Table columns
    material: 'Material',
    spend: 'Spend',
    impressions: 'Impressions',
    clicks: 'Clicks',
    ctr: 'CTR',
    cpm: 'CPM',
    cpc: 'CPC',
    purchases: 'Purchases',
    costPerPurchase: 'Cost/Purchase',
    purchaseValue: 'Purchase Value',
    roi: 'ROI',
    adCount: 'Ad Count',
    mimeType: 'MIME Type',
    // Daily detail dialog
    dailyDetailTitle: 'Daily Consumption — ',
    date: 'Date',
    impressionsShort: 'Impressions',
    clicksShort: 'Clicks',
    purchasesShort: 'Purchases',
    purchaseValueShort: 'Purchase Value',
    summaryLabel: 'Total ({total} rows):',
    // Export
    exportConfirm: 'Export consumption data with current filters?',
    exportTip: 'Notice',
    exportSuccess: 'Exported successfully',
    exportFail: 'Export failed',
    exportFileName: 'Material_Consumption.xlsx',
    // Batch actions
    batchMoveToFolder: 'Move to Folder',
    batchMoveDialogTitle: 'Move Materials',
    batchMoveTip: 'Selected {count} items',
    batchMoveTarget: 'Target Folder',
    batchMoveConfirm: 'Confirm Move',
    batchMoveNoSelection: 'Please select materials first',
    batchMoveSuccess: 'Moved successfully',
    batchMoveFail: 'Move failed',
    unfiled: 'Unfiled'
  },
  insights: {
    // Search
    accountId: 'Account ID',
    accountIdPlaceholder: 'Ad Account ID',
    campaignId: 'Campaign ID',
    campaignName: 'Campaign Name',
    adsetId: 'Adset ID',
    // Dimension tabs
    dimAccount: 'Account',
    dimCampaign: 'Campaign',
    dimAdset: 'Ad Set',
    dimAd: 'Ad',
    dimUser: 'User',
    // Table columns
    adAccountId: 'Account ID',
    createUserName: 'User',
    adAccountName: 'Account Name',
    accountBalance: 'Balance',
    campaignIdCol: 'Campaign ID',
    adsetIdCol: 'Ad Set ID',
    adIdCol: 'Ad ID',
    spend: 'Spend',
    impressions: 'Impressions',
    clicks: 'Clicks',
    ctr: 'CTR',
    purchases: 'Purchases',
    costPerPurchase: 'Cost/Purchase',
    purchaseValue: 'Purchase Value',
    dailyDetail: 'Daily Detail',
    // Summary
    summaryLabel: 'Page Total ({count} rows / {total} total):',
    // Daily detail dialog
    dailyTitle: 'Daily Breakdown — ',
    date: 'Date',
    impressionsShort: 'Impressions',
    clicksShort: 'Clicks',
    // Date shortcuts
    last7days: 'Last 7 days',
    last14days: 'Last 14 days',
    last30days: 'Last 30 days',
    // Dimension prefix
    prefixAccount: 'Account: ',
    prefixCampaign: 'Campaign: ',
    prefixAdset: 'Ad Set: ',
    prefixAd: 'Ad: ',
    prefixUser: 'User: '
  },
  bookSummary: {
    operatorName: 'Media buyer',
    operatorPlaceholder: 'All media buyers',
    spend: 'Spend',
    ctr: 'CTR',
    purchases: 'Purchases',
    costPerPurchase: 'Cost/Purchase',
    purchaseValue: 'Purchase Value',
    roi: 'ROI',
    viewDetail: 'View Detail',
    materialDialogTitle: 'Materials — ',
    materialTopTitle: 'Top 20 Materials by ROI',
    noMaterial: 'No associated material data',
    noBookName: 'Cannot get book name',
    loadMaterialFailed: 'Failed to load material details: ',
    last7days: 'Last 7 days',
    last14days: 'Last 14 days',
    last30days: 'Last 30 days',
    summaryLabel: 'Total ({total} rows):',
    moreFilter: 'Metric filters',
    hideFilter: 'Hide Filters'
  },
  userSummary: {
    userName: 'Creator',
    userNamePlaceholder: 'Search by creator',
    spend: 'Spend',
    ctr: 'CTR',
    purchases: 'Purchases',
    costPerPurchase: 'Cost/Purchase',
    purchaseValue: 'Purchase Value',
    viewDaily: 'Daily Detail',
    dailyDialogTitle: 'Daily Detail — ',
    date: 'Date',
    noUserName: 'Cannot get creator name',
    noData: 'No data available',
    loadDailyFailed: 'Failed to load daily details: ',
    last7days: 'Last 7 days',
    last14days: 'Last 14 days',
    last30days: 'Last 30 days',
    summaryLabel: 'Total ({total} rows):',
    moreFilter: 'More Filters',
    hideFilter: 'Hide Filters'
  },
  strategyAnalysis: {
    dimStrategy: 'Strategy',
    strategyName: 'Strategy Name',
    batchSuccessCount: 'Launch count',
    account: 'Account',
    accountPlaceholder: 'Account ID or name',
    campaignPlaceholder: 'Campaign ID or name',
    adsetPlaceholder: 'Ad set ID or name',
    adPlaceholder: 'Ad ID or name',
    costPerPurchaseShort: 'Cost per purchase',
    totalSpend: 'Total spend',
    totalPurchases: 'Total purchases',
    impressions: 'Impressions',
    cpm: 'CPM',
    cpc: 'CPC',
    linkedMaterials: 'Linked materials',
    sortBy: 'Sort',
    sortOptionCtr: 'CTR',
    pageSummary: 'Page subtotal ({count} rows):',
    ctrInCard: 'CTR',
    costPerPurchaseCard: 'Cost per purchase',
    noMaterials: 'No linked materials',
    warnNoStrategyContext: 'This row has no naming-strategy context; cannot load linked materials.',
    warnInvalidStrategyId: 'Invalid naming strategy ID',
    loadMaterialsFail: 'Failed to load linked materials or request timed out',
    exportConfirm: 'Export data with current filters?',
    exportTipTitle: 'Export',
    exportFileName: 'strategy-report.xlsx',
    exportSuccess: 'Exported',
    exportFail: 'Export failed',
    currentRowFallback: 'Current row'
  },
  booksWithMaterials: {
    pageDesc: 'Books listed below will show material details when clicking "View Detail" in Book Summary.',
    accountId: 'Account ID',
    accountIdPlaceholder: 'Optional, filter by account',
    adAccountId: 'Ad Account ID',
    accountName: 'Account Name',
    viewInSummary: 'View in Book Summary',
    emptyTip: 'No books with material details',
    helpTitle: 'Troubleshooting:',
    help1: '1. material_ad_mapping needs fb_ad_id mappings (batch create, old system sync, or docs/sql/tools/02_manual_mapping_match.sql)',
    help2: '2. fact_insights_daily must have synced data (spend/impressions > 0) in the selected date range',
    help3: '3. dim_campaign_book must include campaign book names (dim sync job)',
    help4: '4. Date range must include CK fact_insights_daily data (min_date~max_date from diagnostic SQL)',
    resultTip: '{total} book(s) with material details (paginated)'
  },
  adTemplate: {
    title: 'Ad Template Management',
    templateName: 'Template Name',
    templateNamePlaceholder: 'Enter template name',
    isDefault: 'Default',
    default: 'Default',
    description: 'Description',
    remark: 'Remark',
    createdAt: 'Created At',
    copy: 'Copy',
    addTitle: 'New Facebook Ad Template',
    editTitle: 'Edit Facebook Ad Template',
    isDefaultTemplate: 'Default Template',
    templateDesc: 'Description',
    templateDescPlaceholder: 'Enter description',
    remarkPlaceholder: 'Enter remark',
    nameRequired: 'Template name is required',
    tabBasic: 'Basic Info',
    tabCampaign: 'Campaign',
    tabAdset: 'Ad Set',
    tabConversion: 'Conversion',
    tabTargeting: 'Targeting',
    tabCreative: 'Creative',
    tabAccount: 'Account',
    campaignName: 'Campaign Name',
    campaignNamePlaceholder: 'Campaign name prefix',
    campaignObjective: 'Campaign Objective',
    campaignDailyBudget: 'Daily Budget (cents)',
    campaignLifetimeBudget: 'Lifetime Budget (cents)',
    specialAdCategory: 'Special Ad Category',
    specialAdCategoryPlaceholder: 'Select special ad category',
    campaignStatus: 'Campaign Status',
    bidStrategy: 'Bid Strategy',
    adsetName: 'Ad Set Name',
    adsetNamePlaceholder: 'Ad set name prefix',
    optimizationGoal: 'Optimization Goal',
    billingEvent: 'Billing Event',
    adsetBidStrategy: 'Bid Strategy',
    adsetDailyBudget: 'Daily Budget (cents)',
    adsetLifetimeBudget: 'Lifetime Budget (cents)',
    adsetStatus: 'Ad Set Status',
    pixelId: 'Facebook Pixel ID',
    pixelIdPlaceholder: 'Enter pixel ID',
    conversionEventType: 'Conversion Event',
    clickAttribution: 'Click Attribution (days)',
    viewAttribution: 'View Attribution (days)',
    attributionWeight: 'Attribution Weight',
    basicTargeting: 'Basic Targeting',
    targetCountry: 'Target Countries',
    targetCountryPlaceholder: 'Select countries',
    genderTargeting: 'Gender',
    genderAll: 'All',
    genderMale: 'Male',
    genderFemale: 'Female',
    ageMin: 'Min Age',
    ageMax: 'Max Age',
    advantageAudience: 'Advantage Audience',
    disabled: 'Disabled',
    enabled: 'Enabled',
    placementConfig: 'Placements',
    devicePlatform: 'Device Platforms',
    devicePlatformPlaceholder: 'Default: All devices',
    publisherPlatform: 'Publisher Platforms',
    publisherPlatformPlaceholder: 'Default: All platforms',
    fbPositions: 'Facebook Positions',
    fbPositionsPlaceholder: 'Default: All positions',
    igPositions: 'Instagram Positions',
    igPositionsPlaceholder: 'Default: All positions',
    flexibleTargeting: 'Flexible Targeting',
    flexibleTargetingJson: 'Flexible Targeting JSON',
    flexibleTargetingHint: 'Groups: AND / Within group: OR. Enter valid JSON array',
    flexibleTargetingError: 'Invalid flexible targeting JSON format',
    creativeName: 'Creative Name',
    creativeNamePlaceholder: 'Enter creative name',
    ctaType: 'Call to Action',
    defaultHeadline: 'Default Headline',
    defaultHeadlinePlaceholder: 'Enter default headline',
    defaultDescription: 'Default Description',
    defaultDescriptionPlaceholder: 'Enter default description',
    defaultBody: 'Default Body Text',
    defaultBodyPlaceholder: 'Enter default body text',
    defaultLandingUrl: 'Default Landing URL',
    defaultImageHash: 'Default Image Hash',
    defaultImageHashPlaceholder: 'Enter image hash',
    defaultVideoId: 'Default Video ID',
    defaultVideoIdPlaceholder: 'Enter video ID',
    adStatus: 'Ad Status',
    fbPageId: 'Facebook Page ID',
    fbPageIdPlaceholder: 'Enter page ID',
    fbAccountId: 'Facebook Account ID',
    accessTokenLabel: 'Access Token',
    accessTokenPlaceholder: 'Enter access token (optional, uses system token if empty)',
    copyPrompt: 'Enter new template name',
    copyTitle: 'Copy Template',
    copySuffix: ' (Copy)',
    copySuccess: 'Copied successfully',
    deleteConfirm: 'Delete template "{name}"?',
    deleteWarning: 'Warning',
    deleteSuccess: 'Deleted successfully',
    batchDeleteConfirm: 'Delete {count} selected template(s)?',
    createSuccess: 'Created successfully',
    updateSuccess: 'Updated successfully',
    operationFail: 'Operation failed',
    getDetailFail: 'Failed to load template'
  },
  batchCreate: {
    title: 'Batch Create Ads',
    cancel: 'Cancel',
    createTask: 'Create Task',
    selectTemplate: 'Template',
    selectTemplatePlaceholder: 'Select ad template (optional)',
    defaultSuffix: ' (Default)',
    adAccount: 'Ad Accounts',
    adAccountPlaceholder: 'Select ad accounts',
    pageId: 'Page ID',
    pageIdPlaceholder: 'Enter Facebook Page ID',
    pixelId: 'Pixel ID',
    pixelIdPlaceholder: 'Enter Facebook Pixel ID',
    campaignConfig: 'Campaign Configuration',
    campaignIndex: 'Campaign {index}',
    campaignName: 'Campaign Name',
    campaignNamePlaceholder: 'Campaign name',
    landingPageUrl: 'Landing Page URL',
    adsetCount: 'Ad Sets Count',
    adTitle: 'Ad Title',
    adTitlePlaceholder: 'Ad title',
    adBody: 'Ad Body',
    adBodyPlaceholder: 'Ad body text',
    selectMaterial: 'Materials',
    selectMaterialPlaceholder: 'Select materials',
    addCampaign: 'Add Campaign',
    previewTitle: 'Ad Structure Preview',
    selectedAssets: 'Selected Assets',
    summaryAssets: '{accounts} accounts, {materials} materials, {campaigns} copies',
    publishTotal: 'Publish Total',
    summaryPublish: '{campaigns} campaigns, {adsets} ad sets, {ads} ads',
    accountRequired: 'Please select at least one ad account',
    campaignRequired: 'Please add at least one campaign',
    campaignNameRequired: 'Please enter Campaign {index} name',
    confirmTitle: 'Confirm Creation',
    confirmMsg: 'About to create {count} ads. Proceed?',
    confirmBtn: 'Confirm',
    successMsg: 'Done! {success} succeeded, {fail} failed',
    failMsg: 'Batch creation failed: '
  }
};
